var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", { staticClass: "grey-color mb-3 main_text font-weight-bold" }, [
        _vm._v("Акты сверки"),
      ]),
      _c("b-table", {
        staticClass: "table-atmo",
        attrs: {
          busy: _vm.loading,
          fields: _vm.fields,
          items: _vm.items,
          "per-page": _vm.pagination.per_page,
          "empty-text": "История пуста",
          "show-empty": "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle mr-1" }),
                    _c("strong", [_vm._v("Загрузка данных...")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(start_balance)",
            fn: function (row) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatPrice(row.item.start_balance)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(replenishments)",
            fn: function (row) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatPrice(row.item.replenishments)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(commission)",
            fn: function (row) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatPrice(row.item.commission)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(end_balance)",
            fn: function (row) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatPrice(row.item.end_balance)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c("action-button-small", {
                  attrs: { icon: "download" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadReport(row.item.id)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm.pagination.total
        ? _c("b-pagination", {
            staticClass: "mt-4 mb-0 mx-auto",
            attrs: {
              "per-page": _vm.pagination.per_page,
              "total-rows": _vm.pagination.total,
              align: "center",
            },
            on: { input: _vm.applyFilters },
            model: {
              value: _vm.pagination.current_page,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "current_page", $$v)
              },
              expression: "pagination.current_page",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }